<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    :class="['inline-block flex-shrink-0', svgClass]"
    aria-hidden="true"
  >
    <defs>
      <linearGradient :id="gradientId" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" :stop-color="from" />
        <stop offset="100%" :stop-color="to" />
      </linearGradient>
    </defs>
    <path
      d="M16 4c-4 0-7 2-9 2s-3 2-3 5c0 4 2 7 3 11 1 3 2 6 4 6 1.5 0 2-2.5 3-6 .5-1.7 1-2 2-2s1.5.3 2 2c1 3.5 1.5 6 3 6 2 0 3-3 4-6 1-4 3-7 3-11 0-3-1-5-3-5s-5-2-9-2z"
      :fill="solid ? color : `url(#${gradientId})`"
    />
  </svg>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  size: { type: [Number, String], default: 28 },
  variant: { type: String, default: 'brand' }, // brand, white, mono
  solid: Boolean,
  svgClass: String
})

const gradientId = computed(() => `le-logo-grad-${Math.random().toString(36).slice(2, 9)}`)

const from = computed(() => {
  if (props.variant === 'white') return '#FFFFFF'
  if (props.variant === 'mono') return 'currentColor'
  return '#2F66E3'
})
const to = computed(() => {
  if (props.variant === 'white') return '#CFFAF3'
  if (props.variant === 'mono') return 'currentColor'
  return '#14B8A6'
})
const color = computed(() => {
  if (props.variant === 'white') return '#FFFFFF'
  if (props.variant === 'mono') return 'currentColor'
  return '#2F66E3'
})
</script>
